$('.media-carousel').each(function () {
  const $this = $(this)
  const $currentSlideInfo = $this.closest('.carousel-container').find('.current-slide')

  // Function to format the numbers with leading zeros
  function formatNumber(num) {
    return num.toString().padStart(2, '0') // Pad with leading zeros
  }

  let swiper = new Swiper(this, {
    navigation: {
      nextEl: $this.closest('.carousel-container').find('.carousel-next')[0],
      prevEl: $this.closest('.carousel-container').find('.carousel-previous')[0],
    },
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 1,
    on: {
      slideChange: function () {
        const currentSlide = this.activeIndex + 1 // Swiper indexes start at 0, so add 1
        $currentSlideInfo.text(formatNumber(currentSlide)) // Update current slide display
      },
    },
  })
})

$('.posts-carousel').each(function () {
  const $this = $(this)

  let swiper = new Swiper(this, {
    navigation: {
      nextEl: $this.closest('.carousel-container').find('.carousel-next')[0],
      prevEl: $this.closest('.carousel-container').find('.carousel-previous')[0],
    },
    grabCursor: true,
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
      1024: {
        slidesPerView: 2,
        spaceBetween: 36,
      },
    },
  })
})

$('.floor-carousel').each(function () {
  const $this = $(this)

  let swiper = new Swiper(this, {
    grabCursor: false,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: false,
    allowTouchMove: false,
    navigation: {
      prevEl: $this.closest('.floor-carousel-container').find('.carousel-previous')[0],
      nextEl: $this.closest('.floor-carousel-container').find('.carousel-next')[0],
    },
    pagination: {
      el: $this.closest('.floor-carousel-container').find('.floor-bullets')[0],
      clickable: true,
      renderBullet: function (index, className) {
        const title = $this
          .closest('.floor-carousel-container')
          .find('.floor-slide')
          .eq(index)
          .attr('data-title')

        return (
          '<div class="floor-bullet h-auto w-full opacity-100 !mx-0 rounded-0 bg-transparent hover:text-rod transition-colors ' +
          className +
          '">' +
          title +
          '</div>'
        )
      },
    },
    on: {
      slideChange: function () {
        // Update the title on slide change
        const activeIndex = this.activeIndex
        const title = $this
          .closest('.floor-carousel-container')
          .find('.floor-slide')
          .eq(activeIndex)
          .attr('data-title')

        // Update the title in the floor toggle button
        $('.floor-toggle-button .floor-title').html(title)
      },
    },
  })

  $this
    .closest('.floor-carousel-container')
    .find('.floor-bullet')
    .on('click', function () {
      toggleFloorOptions()

      $('.floor-toggle-button .floor-title').html($(this).html())
    })
})

$('.floor-toggle-button').on('click', function () {
  toggleFloorOptions()
})

function toggleFloorOptions() {
  $('.floor-toggle-options').slideToggle(300)
  $('.floor-toggle-options-container').toggleClass('bg-color-2')
  $('.floor-toggle-button .icon').toggleClass('rotate-45')
}

$('.timeline-carousel').each(function () {
  var $this = $(this)

  var slidesPerView = $this.attr('data-slides-per-view')

  var swiper = new Swiper(this, {
    pagination: false,
    navigation: {
      nextEl: $this.parents('.carousel-container').find('.carousel-next')[0],
      prevEl: $this.parents('.carousel-container').find('.carousel-previous')[0],
    },
    slidesPerView: 1.2,
    breakpoints: {
      1024: {
        slidesPerView: slidesPerView,
      },
    },
    spaceBetween: 0,
    grabCursor: true,
  })
})
